var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timelineChart",style:({height: _vm.height + 30})},[(_vm.title)?_c('h4',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('ve-line',{attrs:{"data":_vm.chartData,"data-zoom":_vm.dataZoom}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }